import useCheckRole from "Hooks/APICheckRole";
import APICodeDeckProvider from "Providers/APICodeDeckProvider";
import APIProductTableProvider from "Providers/APIProductTableProvider";
import APIRatingTableProvider from "Providers/APIRatingTableProvider";
import React, { useState } from "react";
import { Container } from "semantic-ui-react";
import CodeDeckView from "./CodeDeck/CodeDeckView";
import ProductTableView from "./ProductTable/ProductTableView";
import RatingTableView from "./RatingTable/RatingTableView";

const BillingView = () => {
  const [activeView, setActiveView] = useState("rates");
  const { hasRole, roles } = useCheckRole();
  const isRatingTable = hasRole(roles.billing.rates.roles.view);
  const isProductTable = hasRole(roles.billing.products.roles.view);
  const isCodeDeck = hasRole(roles.billing.codes.roles.view);
  return (
    <Container fluid>
      {activeView === "rates" && isRatingTable && (
        <APIRatingTableProvider>
          <RatingTableView
            selectView={(value: string) => setActiveView(value)}
          />
        </APIRatingTableProvider>
      )}
      {activeView === "products" && isProductTable && (
        <APIProductTableProvider>
          <ProductTableView
            selectView={(value: string) => setActiveView(value)}
          />
        </APIProductTableProvider>
      )}
      {activeView === "codes" && isCodeDeck && (
        <APICodeDeckProvider>
          <CodeDeckView selectView={(value: string) => setActiveView(value)} />
        </APICodeDeckProvider>
      )}
    </Container>
  );
};

export default BillingView;
